export default "__VITE_ASSET__BiYM78fN__"